import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getSlatSize } from '../../../helpers/slatSize';
import { throwError } from '../../../helpers/throwError';
import { BaseProduct, ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  slatSize: string,
  colour: string,
  products: BaseProduct[],
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (slatSize, colour, products, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      slatSize,
    },
  });
}

export const SlatSize = () => {
  const [state, send] = useService(productBuilderMachine);
  const { 
    products,
    custom: {
      slatSize,
      colour
    }
   } = state.context;
  const productType = getBaseProductType(state.context);
  const slatSizeOptions = getSlatSize(state.context);

  if (isCurrentState('slatSize', state) && slatSizeOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Slat Size</Heading>
      <Selector isSlider={true}>
        {slatSizeOptions.map(option => {
          const isSelected = option === slatSize;
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'slatSize',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={isSelected}
              onClick={onClick(option, colour, products, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
